<template>
	<div class="w-full flex flex-col items-start hierarchy-select guides-hierarchy-select">
		<ul class="w-full flex flex-column">
			<li
				v-for="(module, moduleIndex) in value"
				:key="GetModuleKey(module, moduleIndex)"
				class="w-full list-unstyled flex flex-col my-1"
			>
				<div
					class="flex items-center"
					@click.stop.prevent="ToggleModule(module)"
				>
					<div class="flex-1 py-1 level-1-color">
						<span
							class="flex-1 text-uppercase text-ellipsis font-bold font-level font-level-1"
						>
							{{ module.name }}
						</span>
					</div>
					<button
						type="button"
						class="action-button"
						@click.stop.prevent="ConfigModule(module)"
					>
						<i class="fal fa-cog"></i>
					</button>
					<button
						type="button"
						class="action-button expand-indicator-container"
						@click.stop.prevent="ToggleModule(module)"
					>
						<i :class="GetChevronIcon(module)"></i>
					</button>
				</div>

				<div
					v-if="module.children?.length && module.expanded"
					class="children ml-5"
				>
					<ul class="w-full flex flex-column">
						<li
							v-for="(modality, modalityIndex) in module.children"
							:key="GetModalityKey(modality, modalityIndex)"
							class="w-full list-unstyled flex flex-col my-1"
						>
							<div class="flex items-center">
								<div class="flex-1 py-1 level-2-color">
									<span
										class="flex-1 text-uppercase text-ellipsis font-bold font-level font-level-2"
									>
										{{ modality.name }}
									</span>
								</div>
								<button
									type="button"
									class="action-button"
									@click.stop.prevent="ConfigModality(modality)"
								>
									<i class="fal fa-cog"></i>
								</button>
							</div>
						</li>
					</ul>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'GuidesHierarchySelect',
		props: {
			value: {
				type: Array,
				required: true,
			},
		},
		methods: {
			ToggleModule(module) {
				if (!module.children?.length) return

				module.expanded = !module.expanded
				this.$emit('change')
			},
			ConfigModule(module) {
				this.ConfigItem('module', module)
			},
			ConfigModality(modality) {
				this.ConfigItem('modality', modality)
			},
			ConfigItem(type, item) {
				this.$emit('config', type, item)
			},
			GetChevronIcon(module) {
				return module.expanded
					? 'fal fa-chevron-down'
					: 'fal fa-chevron-right'
			},
			GetModuleKey(module, index) {
				return `module-${module.id}-${index}`
			},
			GetModalityKey(modality, index) {
				return `modality-${modality.id}-${index}`
			},
		},
	}
</script>

<style lang="scss" scoped>
	.expand-indicator-container {
		display: flex;
		align-items: center;
	}

	.action-button {
		height: 30px;
		width: 30px;
		background-color: transparent;
		color: var(--fontColor);
		border-radius: 0.4rem;
		display: flex;
		align-items: center;
		justify-content: center;
		outline: none;
		border: none;
		transition: all 0.2s;
		margin-right: 0.75rem;

		&:hover {
			background-color: var(--newPrimaryBackgroundColor);
			color: var(--white);
		}
	}
</style>